module.exports = __webpack_public_path__ + "static/media/pin1.f9b836aa.png";